<script>
import { getUserData } from '@/auth/utils'
import { lockForRoute } from '@/utils/membership'
import MembershipLocked from '@/views/memberships/MembershipLocked.vue'

// Envuelve al router-view: cuando la pantalla pertenece a un plan que el cliente no tiene,
// o ya llego al cupo de su plan, se renderiza el aviso en su lugar. La ruta y el menu no se
// tocan, asi que el cliente ve donde esta parado, y la vista real nunca se monta, asi que
// tampoco pega a la API para recibir un 403.
export default {
  name: 'MembershipGate',

  computed: {
    membership() {
      return this.$store.getters['memberships/currentMembership']
    },

    isCustomer() {
      const user = this.$store.getters['auth/currentUser'] || getUserData()
      return user?.role_name === 'customer'
    },

    lock() {
      if (!this.isCustomer) return null

      return lockForRoute(this.membership, this.$route.name)
    },
  },

  render(h) {
    if (this.lock) {
      return h(MembershipLocked, {
        props: { featureKey: this.lock.featureKey, kind: this.lock.kind },
      })
    }

    const nodes = (this.$slots.default || []).filter(node => node.tag)
    return nodes[0] || h('div')
  },
}
</script>
